import React from 'react';

import { map as _map, isFunction as _isFunction } from 'lodash';
import PropTypes from 'prop-types';

import BillingTestKeys from '../../Utils/BillingTestKeys.js';
import ExpansionPanel from '../ExpansionPanel';
import VfView from '../VfView';

import styles from './SubscriptionsList.Styles';

function SubscriptionsList({
  subscriptions,
  withCTA,
  ctaProps,
  renderBreakDownItem,
  onShowMorePress,
  showMoreText,
  showLessText,
  toggleModal,
}) {
  return _map(subscriptions, (subscription, index) => {
    if (_isFunction(renderBreakDownItem)) {
      return renderBreakDownItem(subscription, index);
    }

    return (
      <VfView key={index} style={styles.itemContainerStyle}>
        <ExpansionPanel
          isLoading={false}
          buttonTitleOpen={showMoreText}
          buttonTitleClose={showLessText}
          withCTA={withCTA}
          ctaProps={ctaProps}
          subscription={subscription}
          {...subscription}
          onShowMorePress={onShowMorePress}
          showMoreTestID={`${BillingTestKeys.billDetailsSubscriptionsListShowmoreBtn}`}
          toggleModal={toggleModal}
        />
      </VfView>
    );
  });
}

SubscriptionsList.defaultProps = {
  showMoreText: 'billing_payment_breakdown_btn_more',
  showLessText: 'billing_payment_breakdown_btn_less',
};

SubscriptionsList.propTypes = {
  subscriptions: PropTypes.array,
  withCTA: PropTypes.bool,
  ctaProps: PropTypes.object,
  renderBreakDownItem: PropTypes.func,
  onShowMorePress: PropTypes.func,
  showMoreText: PropTypes.string,
  showLessText: PropTypes.string,
};

export default SubscriptionsList;
